import { IUserReturn } from '@/bundles/Auth/interfaces/IUserReturn';

export class MultiAuthReturn {
  user!: IUserReturn;
  access_token!: string;
}
